<template>
    <div class="enviados">
        <vs-table v-if="enviar_correo" class="table-responsive" v-dragscroll="{ target: '.vs-table', active: true }" :key="compChild">
            <template #tbody>
            <vs-tr
                :key="i"
                v-for="(tr, i) in guardados"
                :data="tr"
                style="border-bottom: 1px solid #cccc; cursor:pointer"
            >
                <vs-td  v-if="tr.sended === 0" @click="showGuardado = !showGuardado; selectedRow = tr; enviar_correo = false ">
                    <strong> {{ tr.subject }} </strong>
                </vs-td>
                <vs-td v-if="tr.sended === 0" @click="showGuardado = !showGuardado; selectedRow = tr; enviar_correo = false">
                 <md-chip class="mb-1 fontMedium mini-chip col-blue"> <strong>{{ tr.cicloescolar.nombre_ciclo }}</strong></md-chip>
                </vs-td>
                <vs-td v-if="tr.sended === 0" @click="showGuardado = !showGuardado; selectedRow = tr; enviar_correo = false">
                    <i v-if="tr.attachments[0]" class="fas fa-paperclip"></i>
                </vs-td>
            </vs-tr>
            </template>
            <template #notFound>
                No hay correos guardados.
            </template>
            <template #footer>
                <vs-pagination  v-model="page" :length="pages" />           
            </template>
        </vs-table>
        <enviar v-if="showGuardado" :info="selectedRow" :institucion="institucion" :cicloEscolar="cicloEscolar" @refreshTable="getRefreshTable()"></enviar>
    </div>
</template>

<script>
import enviar from './correo-guardados'
import mailing from '../../../api/requests/mailing.js'
export default {
    props: [
        'guardados',
        'institucion',
        'cicloEscolar',
        'guardadosInfo',
        'pages'
    ],
    data() {
        return{
            info: [],
            showGuardado: false,
            enviar_correo: true,
            compChild: 0,
            search: '',
            page: 1
        }
    },
    components: {
        enviar
    },
    methods:{
        getRefreshTable(){
            this.$emit('refreshTable', true);
        },
        getShowReenviar(tr, i){
            this.showGuardado = true
            this.enviar_correo = false
            this.info = tr
        },
    },
    watch:{
        enviar_correo(){
            this.enviar_correo = false
            this.$emit('reAbrirGuardados', true);
        },
        guardados(){
            this.compChild += 1; 
        },
        page(){
            this.$emit('refreshTablePage', this.page);
        }
    }
}
</script>

<style>
    .enviados .table-responsive{
        margin-top: 3% !important;
    }
</style>
<style scoped>
    .vs-table{
        overflow-x: none;
    }

    .vs-table__tbody{
        vertical-align: top !important;
    }

    .col-yellow{
        background: rgb(255, 248, 236);
        color: #febf3d;
    }

    .col-red{
        color: #f62d51;
        background: rgb(249, 231, 235);
    }

    .col-green{
        color: #55ce63;
        background: rgb(232, 253, 235);
    }

    .col-purple{
        color: purple;
        background: rgb(232, 218, 239);
    }

    .col-blue{
        color: #2874A6;
        background: rgb(214, 234, 248);
    }

    .col-gray{
        color: #5F6A6A;
        background: rgb(242, 243, 244);
    }

    .col-pink{
        color: #F08080;
        background: rgb(255, 236, 236);
    }

    .col-brown{
        color: #784212;
        background: rgb(250, 229, 211);
    }

    .md-chip{
        height: 24px !important;
        line-height: 24px !important;
    }
</style>